import { CascadingMenu } from './cascading-menu';

export * from './cascading-menu-item';
export * from './menu.props';

export default CascadingMenu;
